module.exports = __webpack_public_path__ + "static/Amelanchier canadensis (Serviceberry)-e47c4fc3c1a979decea88b92006ab399.jpg";